var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorIconMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doctor-icon",
    transform: "translate(8.4 8.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1278",
    "data-name": "Rectangle 1278",
    width: 56,
    height: 56,
    rx: 8,
    transform: "translate(-8.4 -8.4)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "doctor-icon-2",
    "data-name": "doctor-icon",
    d: "M37.149,25.292a5.051,5.051,0,1,0-6.628,4.852,7.3,7.3,0,0,1-14.3-2.013V26.205a2.537,2.537,0,0,0,.457-.346L24.874,17.7l.248-.252A7.554,7.554,0,0,0,23.664,5.537,3.738,3.738,0,1,0,19.946,9.6,3.714,3.714,0,0,0,22.9,8.116a5.01,5.01,0,0,1,.407,7.515l-8.362,8.335-8.122-8.09-.262-.254a5.033,5.033,0,0,1,0-7.157,5.153,5.153,0,0,1,.434-.37,3.713,3.713,0,0,0,2.95,1.481A3.789,3.789,0,1,0,6.225,5.525,7.678,7.678,0,0,0,4.755,6.644a7.6,7.6,0,0,0,.008,10.81l8.449,8.411a2.512,2.512,0,0,0,.445.343v1.924a9.864,9.864,0,0,0,19.469,2.187,5.123,5.123,0,0,0,4.023-5.027Z",
    transform: "translate(-0.867 -0.367)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIconMenu);
export default __webpack_public_path__ + "static/media/doctor-icon-menu.cf4acdb8ca9e5ca6af6a06cf725a2f17.svg";
export { ForwardRef as ReactComponent };